import buildGraphQLProvider, { buildQuery as buildQueryFactory } from 'ra-data-graphql-simple';
import { __schema as schema } from '../schema.json';
import client from './apollo'
import gql from 'graphql-tag';
import { CREATE } from 'ra-core';

const customBuildQuery = introspectionResults => {
    const buildQuery = buildQueryFactory(introspectionResults);

    return (type, resource, params) => {
        // I need to intercept this code block, because it can not be handled by simple graphQL handler
        // PARS Server returns an array result because of multiple code generation. Workaround solution.
        if (type === CREATE && resource === 'Code') {
            return {
                query: gql`mutation create${resource}($campaignId:String,$bundleId:String,$tags:[String],$count:Int,$markAsSent:Boolean) {
                    items: create${resource}(campaignId: $campaignId, bundleId: $bundleId, tags: $tags, count: $count, markAsSent:$markAsSent) {
                      id
                      code
                      channelId
                      campaignId
                      bundleId
                      tags
                      maxUsage
                      description
                      url
                      dateCreated
                      dateModified
                      dateSent
                      dateFirstUsed
                      dateLastUsed
                    }
                }`,
                variables: {
                    campaignId: params.data.campaignId, bundleId: params.data.bundleId,
                    tags: params.data.tags, count: params.data.count, markAsSent:params.data.markAsSent
                },
                parseResponse: ({ data }) => {
                    return { data: data.items[0] };
                },
            };
        }

        return buildQuery(type, resource, params);
    };
};

const GraphQLDataProvider = () => {
    return buildGraphQLProvider(
        {
            client,
            introspection: {
                schema,
            },
            buildQuery: customBuildQuery,
        })
};

export default GraphQLDataProvider;